var _stop, _stop2, _stop3, _stop4, _stop5, _stop6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgCheckmarkBordered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "m71.236 34.635-3.542-2.17a6.957 6.957 0 0 1-2.478-9.256l1.984-3.65a1.598 1.598 0 0 0-1.366-2.365l-4.141-.104a6.955 6.955 0 0 1-6.783-6.783l-.104-4.141A1.6 1.6 0 0 0 52.442 4.8L48.79 6.784a6.957 6.957 0 0 1-9.256-2.48l-2.17-3.54a1.598 1.598 0 0 0-2.729 0l-2.17 3.542a6.958 6.958 0 0 1-9.256 2.478L19.559 4.8a1.598 1.598 0 0 0-2.365 1.366l-.104 4.141a6.955 6.955 0 0 1-6.783 6.783l-4.141.104A1.6 1.6 0 0 0 4.8 19.558l1.984 3.652a6.958 6.958 0 0 1-2.48 9.256l-3.54 2.17a1.598 1.598 0 0 0 0 2.729l3.542 2.17a6.957 6.957 0 0 1 2.478 9.256L4.8 52.441a1.598 1.598 0 0 0 1.366 2.365l4.141.104a6.955 6.955 0 0 1 6.783 6.783l.104 4.141a1.6 1.6 0 0 0 2.364 1.366l3.652-1.984a6.958 6.958 0 0 1 9.256 2.48l2.17 3.54a1.598 1.598 0 0 0 2.729 0l2.17-3.542a6.957 6.957 0 0 1 9.256-2.478l3.65 1.984a1.598 1.598 0 0 0 2.365-1.366l.104-4.141a6.955 6.955 0 0 1 6.783-6.783l4.141-.104a1.6 1.6 0 0 0 1.366-2.364l-1.984-3.652a6.958 6.958 0 0 1 2.48-9.256l3.54-2.17a1.598 1.598 0 0 0 0-2.729Zm-5.214 2.171a10.156 10.156 0 0 0-3.618 13.513l.735 1.353-1.527.038a10.152 10.152 0 0 0-9.902 9.902l-.039 1.527-1.352-.735a10.155 10.155 0 0 0-13.513 3.618L36 67.338l-.806-1.316a10.153 10.153 0 0 0-13.513-3.619l-1.353.735-.038-1.527a10.152 10.152 0 0 0-9.902-9.902l-1.527-.039.735-1.352a10.157 10.157 0 0 0-3.618-13.513L4.662 36l1.316-.806A10.156 10.156 0 0 0 9.596 21.68l-.735-1.353 1.527-.038a10.152 10.152 0 0 0 9.902-9.902l.039-1.527 1.352.735a10.157 10.157 0 0 0 13.513-3.618L36 4.662l.806 1.316A10.155 10.155 0 0 0 50.32 9.596l1.353-.735.038 1.527a10.152 10.152 0 0 0 9.902 9.902l1.527.039-.735 1.352a10.157 10.157 0 0 0 3.618 13.513l1.316.806-1.316.806Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id2, ")"),
    d: "M45.963 27.11a1.6 1.6 0 0 0-2.232.373L33.99 41.12l-5.89-5.89a1.6 1.6 0 1 0-2.263 2.262l7.226 7.226a1.598 1.598 0 0 0 2.433-.201l10.84-15.175a1.599 1.599 0 0 0-.372-2.232Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id3, ")"),
    d: "M36 14.77c-11.706 0-21.23 9.524-21.23 21.23 0 11.706 9.524 21.23 21.23 21.23 11.706 0 21.23-9.524 21.23-21.23 0-11.706-9.524-21.23-21.23-21.23Zm0 39.26c-9.942 0-18.03-8.088-18.03-18.03 0-9.942 8.088-18.03 18.03-18.03 9.942 0 18.03 8.088 18.03 18.03 0 9.941-8.088 18.03-18.03 18.03Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 36,
    x2: 36,
    y1: 0,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA200"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 36,
    x2: 36,
    y1: 26.813,
    y2: 45.188,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA200"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 36,
    x2: 36,
    y1: 14.77,
    y2: 57.23,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA200"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBordered);
export default __webpack_public_path__ + "static/media/checkmark_bordered.6c654d0dbf4085b7094dd1618a7b72cc.svg";
export { ForwardRef as ReactComponent };